module.exports = __webpack_public_path__ + "img/MAS.80ae3adf.svg";